import React from "react";
import styles from "../../styles/home/ListSection.module.scss";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { Slide } from "react-awesome-reveal";
import { isBrowser, isMobile } from "react-device-detect";

const ListSection = ({
  listItems,
  product,
  hasButton,
  buttonLabel,
  ctaLink,
  subtitle,
  topLine,
  lightTopLine,
  hoverStyle,
  slideUp,
}) => {
  const ctaText = () => (isMobile ? "Get Started" : buttonLabel);

  const renderListItems = () => {
    return listItems.map((item, i) => {
      const imageHolderClass = classnames({
        [styles.imageHolder]: true,
        [styles.hasImage]: item.img,
      });
      const descContainerClass = classnames({
        [styles.description]: true,
        [styles.hasImage]: item.img,
      });
      const cardCaptionClass = classnames({
        [styles.cardCaption]: true,
        [styles.hasImage]: item.img,
      });
      const cardClass = classnames({
        [styles.card]: true,
        [styles.hoverStyle]: hoverStyle,
      });

      const imageStyles = {
        background: item.img ? `url(${item.img}) 0 0 no-repeat` : null,
        backgroundSize: item.img ? "cover" : null,
      };
      return (
        <a className={cardClass} key={i} href={item.link} rel="noopener noreferrer" target="_blank">
          <div className={imageHolderClass} style={imageStyles}>
            <h2 className={styles.subtitle}>{item.title}</h2>
          </div>
          <div className={cardCaptionClass}>
            {item.descTitle && (
              <h1 className={styles.descriptionHeader}>{item.descTitle}</h1>
            )}
            <p className={descContainerClass}>{item.description}</p>
          </div>
        </a>
      );
    });
  };

  return (
    <div className={classnames(styles.listSection, styles[product])}>
      <h1
        className={styles.header}
        style={{ color: lightTopLine ? "#fff" : "#000" }}
      >
        {topLine}
      </h1>

      {isBrowser && slideUp ? (
        <Slide direction="up" triggerOnce fraction={0.2}>
          <div className={styles.wrapper}>
            <>{renderListItems()}</>
          </div>
        </Slide>
      ) : (
        <div className={styles.wrapper}>
          <>{renderListItems()}</>
        </div>
      )}

      {hasButton && (
        <div className={styles.downloadWrapper}>
          <p className={styles.description}>{subtitle}</p>
          <Link to={ctaLink}>
            <button className={styles.button}>{ctaText()}</button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default ListSection;
